<template>
	<div>
		<pdf
				v-for="i in numPages"
				:key="i"
				:src="src"
				:page="i"
				style="width: 60%;
		height: 60%;
		margin: 0 auto;
		padding-top: 30px;"
			></pdf>
	</div>
</template>

<script>

import pdf from 'vue-pdf'

export default {
	components: {
		pdf
	},
	data() {
		return {
			src: '',
			numPages: undefined,
		}
	},
	mounted() {
		this.src.promise.then(pdf => {
			this.numPages = pdf.numPages;
		});
	},
	created() {
		// console.log("路由参数",this.$route)
		this.src = pdf.createLoadingTask(this.$route.params.url)
    }
}

</script>



// WEBPACK FOOTER //
// pdfPreview.vue?5c05d9ea